import { DateTime } from 'luxon';

export const notesRedirectTarget = (teamId: string) => ({
  to: '/$teamId/notes' as const,
  params: { teamId },
});

export const libraryRedirectTarget = (teamId: string) => ({
  to: '/$teamId/library/exercises' as const,
  params: { teamId },
});

export const blockRedirectTarget = (teamId: string, blockId: string) => ({
  to: '/$teamId/block/$blockId' as const,
  params: { teamId, blockId },
});

export const planRedirectTarget = (teamId: string) => ({
  to: '/$teamId/plan' as const,
  params: { teamId },
});

export const teamRedirectTarget = (teamId: string) => ({
  to: '/$teamId/team/profiles' as const,
  params: { teamId },
});

export const actualsRedirectTarget = (teamId: string) => ({
  to: '/$teamId/actuals/$date' as const,
  params: { teamId, date: DateTime.now().toISODate() },
});

export const ORG_SWITCH_REDIRECT_TARGET = '/' as const;
